import React from 'react';
import ReactDOM from 'react-dom/client';
import createSagaMiddleware from 'redux-saga';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore, compose } from 'redux';

import './styles/main.css';

import App from './App';
import Saga from './sagas/saga';
import reducer from './reducers/reducer';

import { IntlProvider } from 'react-intl';
import messages_en from './translations/en.json';
import messages_zh from './translations/zh.json';

// Define your translations
const messages = {
  en: messages_en,
  zh: messages_zh
};
const language = 'en';

// Create middlewares
const sagaMiddleware = createSagaMiddleware();

const middleware = applyMiddleware(
  sagaMiddleware
);

// Create store
const store = createStore(reducer, compose(middleware));

// Run saga middleware
sagaMiddleware.run(Saga);

console.log("In index.js store %o", store);

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <IntlProvider locale={language} messages={messages[language]}>
      <Provider store={store}>
        <App />
      </Provider>
    </IntlProvider>
  );
} else {
  console.error('Root element not found');
}
